import React, {useState} from "react";
import {
    DayInterface,
    PeriodInterface,
    PeriodInterfaceTPInterface
} from "../../../service/Business/Interfaces/CalendarInterface";
import FCDatePicker from "../../FCObjets/Form/FCDatePicker";
import {AddPeriod, AddPeriodTP, DeletePeriod, UpdatePeriod} from "../../../service/Business/CalendarService";
import {getIdWithToken} from "../../../utils/storage/Token";
import {CallbackErrorModalFL, CallbackFinishedModalFL} from "../../Dashboard/Form/ModalForm";
import TypePeriod from "../../../utils/Business/TypePeriod";
import FCSelect from "../../FCObjets/Form/FCSelect";
import FCCheckbox from "../../FCObjets/Form/FCCheckbox";
import {useToast} from "../../FCObjets/FCToast/FCToast";
import "./FormAtelier.scss";

type FormPeriodProps = {
    onFinished: CallbackFinishedModalFL;
    onError: CallbackErrorModalFL;
    dataPeriod: PeriodInterface | undefined;
};

const FormPeriod: React.FunctionComponent<FormPeriodProps> = ({dataPeriod, onFinished, onError}) => {
    const toast = useToast();
    const [inputDateBegin, setInputDateBegin] = useState(dataPeriod ? new Date(dataPeriod.begin) : null);
    const [inputDateEnd, setInputDateEnd] = useState(dataPeriod ? new Date(dataPeriod.end) : null);
    const [inputPeriod, setInputPeriod] = useState(dataPeriod ? dataPeriod.type : 0);
    const [inputDay, setInputDay] = useState<DayInterface>({
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true
    });


    const optionsDrop = TypePeriod.ListType.map((t) => ({
        value: t,
        label: TypePeriod.toString(t)
    }));
    const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});

    /**
     * Validation du formulaire
     */
    const handleSubmit = () => {
        const errors: Record<string, string> = {};

        if (!inputDateBegin) errors.dateBegin = "La date de début est obligatoire.";
        if (!inputDateEnd) errors.dateEnd = "La date de fin est obligatoire.";
        if (inputDateBegin && inputDateEnd && inputDateEnd < inputDateBegin) errors.dateEnd = "La date de fin doit être postérieure à la date de début.";

        if (Object.keys(errors).length > 0) {
            setFieldErrors(errors);
            toast.error(Object.values(errors).join(" "), "Validation");
            return;
        }
        setFieldErrors({});

        if (dataPeriod) {
            const period: PeriodInterface = {
                begin: inputDateBegin ? inputDateBegin.toDateString() : "",
                end: inputDateEnd ? inputDateEnd.toDateString() : "",
                id: dataPeriod ? dataPeriod.id : -1,
                type: inputPeriod
            };

            UpdatePeriod(getIdWithToken(), period).then(() => {
                toast.success("Période modifiée avec succès.", "Planning");
                onFinished();
            }).catch((err) => onError(err));
        } else {
            if (!inputDay.friday || !inputDay.monday || !inputDay.wednesday || !inputDay.thursday || !inputDay.thursday) {
                const period: PeriodInterfaceTPInterface = {
                    begin: inputDateBegin ? inputDateBegin.toDateString() : "",
                    end: inputDateEnd ? inputDateEnd.toDateString() : "",
                    id: -1,
                    type: inputPeriod,
                    day: inputDay
                };
                AddPeriodTP(getIdWithToken(), period).then(() => {
                    toast.success("Période ajoutée avec succès.", "Planning");
                    onFinished();
                }).catch((err) => onError(err));
            }
            else {
                const period: PeriodInterface = {
                    begin: inputDateBegin ? inputDateBegin.toDateString() : "",
                    end: inputDateEnd ? inputDateEnd.toDateString() : "",
                    id: -1,
                    type: inputPeriod
                };

                AddPeriod(getIdWithToken(), period).then(() => {
                    toast.success("Période ajoutée avec succès.", "Planning");
                    onFinished();
                }).catch((err) => onError(err));
            }

        }
    }

    const manageInputDay = (day: number, value: boolean) => {
        let i = {...inputDay};
        if (day === 0) {
            i.monday = value;
        } else if (day === 1) {
            i.tuesday = value;
        } else if (day === 2) {
            i.wednesday = value;
        } else if (day === 3) {
            i.thursday = value;
        } else if (day === 4) {
            i.friday = value;
        }
        setInputDay(i);
    }

    return (
        <form className="fcaForm" onSubmit={(e) => e.preventDefault()}>
            <div className="fcaSection">
                <div className="fcaSectionLabel">Période</div>

                <div className="fcaRow">
                    <div className={`fcaField${fieldErrors.dateBegin ? " fcaField--error" : ""}`}>
                        <FCDatePicker onChangeHandler={setInputDateBegin} value={inputDateBegin} id={"deb"}
                                      label={"Début :"}/>
                        {fieldErrors.dateBegin && <span className="fcaFieldError">{fieldErrors.dateBegin}</span>}
                    </div>
                    <div className={`fcaField${fieldErrors.dateEnd ? " fcaField--error" : ""}`}>
                        <FCDatePicker onChangeHandler={setInputDateEnd} value={inputDateEnd} id={"fin"} label={"Fin :"}/>
                        {fieldErrors.dateEnd && <span className="fcaFieldError">{fieldErrors.dateEnd}</span>}
                    </div>
                </div>

                <FCSelect
                    options={optionsDrop}
                    value={inputPeriod}
                    onChange={(v) => setInputPeriod(Number(v))}
                />
            </div>

            {dataPeriod === undefined && (
                <div className="fcaSection">
                    <div className="fcaSectionLabel">Jours travaillés</div>
                    <FCCheckbox onChangeHandler={(e) => manageInputDay(0, e.target.checked)}
                                label={"Lundi"} id={"monday"}
                                value={inputDay.monday} widthLabel={"200px"}/>
                    <FCCheckbox onChangeHandler={(e) => manageInputDay(1, e.target.checked)}
                                label={"Mardi"} id={"tuesday"}
                                value={inputDay.tuesday} widthLabel={"200px"}/>
                    <FCCheckbox onChangeHandler={(e) => manageInputDay(2, e.target.checked)}
                                label={"Mercredi"} id={"wednesday"}
                                value={inputDay.wednesday} widthLabel={"200px"}/>
                    <FCCheckbox onChangeHandler={(e) => manageInputDay(3, e.target.checked)}
                                label={"Jeudi"} id={"thursday"}
                                value={inputDay.thursday} widthLabel={"200px"}/>
                    <FCCheckbox onChangeHandler={(e) => manageInputDay(4, e.target.checked)}
                                label={"Vendredi"} id={"friday"}
                                value={inputDay.friday} widthLabel={"200px"}/>
                </div>
            )}

            <div className="fcaActions">
                {dataPeriod && (
                    <button type="button" className="fcaBtn fcaBtnSecondary"
                            style={{color: "var(--color-error, #E74C3C)"}}
                            onClick={() => {
                                DeletePeriod(getIdWithToken(), dataPeriod).then(() => {
                                    toast.success("Période supprimée.", "Planning");
                                    onFinished();
                                });
                            }}>
                        <span className="material-symbols-outlined">delete</span>
                        Supprimer
                    </button>
                )}
                <button type="button" className="fcaBtn fcaBtnSecondary" onClick={() => onFinished()}>
                    Annuler
                </button>
                <button type="button" className="fcaBtn fcaBtnPrimary" onClick={handleSubmit}>
                    <span className="material-symbols-outlined">check</span>
                    Valider
                </button>
            </div>
        </form>
    );
}

export default FormPeriod;